module.exports = __webpack_public_path__ + "site/img/69.ea6e15d7.jpg";